export default "__VITE_ASSET__oHCfbDrE__"